import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { getAuthToken, removeAuthToken } from "@/utils/token";
import routes from "@/config/routes.ts";

const Axios = axios.create({
  baseURL: import.meta.env.EDS_HOST_API,
  // timeout: 10000, // 10 seconds
  timeout: 100000, // 10 seconds
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

Axios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token as string}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

Axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (
      (error.response && error.response.status === 401) ||
      (error.response && error.response.status === 403)
    ) {
      removeAuthToken();
      // if route is not login, redirect to login
      if (window.location.pathname !== routes.login) {
        window.location.href = routes.login;
      }
    }
    return Promise.reject(error);
  },
);

export class HttpClient {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(
    url: string,
    data: unknown,
    options?: AxiosRequestConfig,
  ) {
    const response = await Axios.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(
    url: string,
    data: unknown,
    options?: AxiosRequestConfig,
  ) {
    const response = await Axios.put<T>(url, data, options);
    return response.data;
  }

  static async patch<T>(
    url: string,
    data: unknown,
    options?: AxiosRequestConfig,
  ) {
    const response = await Axios.patch<T>(url, data, options);
    return response.data;
  }

  static async delete<T>(url: string, options?: AxiosRequestConfig) {
    const response = await Axios.delete<T>(url, options);
    return response.data;
  }
}